import { Application } from "../main";
import { GPSCoordinate } from "./gpscoordinate";

export class UserLocation {
    private static _lastResult:GeolocationPosition;
    public static validityDuration:number = 3*60*1000;
    public static last():GPSCoordinate|null {
        if(UserLocation._lastResult!=null&&UserLocation._lastResult?.coords?.latitude!=null) {
            return new GPSCoordinate(UserLocation._lastResult.coords.latitude, UserLocation._lastResult.coords.longitude);
        }
        return null;
    }
    public static getCurrent():Promise<GPSCoordinate> {
        return new Promise((resolve,reject) => {
            if(UserLocation._lastResult!=null&&Date.now()-UserLocation._lastResult.timestamp<UserLocation.validityDuration) {
                resolve(new GPSCoordinate(UserLocation._lastResult.coords.latitude, UserLocation._lastResult.coords.longitude));
            } else {
                Application.events.dispatch("locate_user_start");
                navigator.geolocation.getCurrentPosition(
                    (position:GeolocationPosition) => {
                        UserLocation._lastResult = position;
                        Application.events.dispatch("locate_user_complete");
                        resolve(new GPSCoordinate(UserLocation._lastResult.coords.latitude, UserLocation._lastResult.coords.longitude));
                    },
                    (error:any) => {
                        Application.events.dispatch("locate_user_complete");
                        reject(error);
                    }
                );
            }
        });
    }
}